import NoNameLogo from "../../assets/images/brand-logo.svg?react";
import { ReactElement, useRef } from "react";
import useFontFaceObserver from "use-font-face-observer";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/redux-store";

export interface SurveySummaryEntryProps {
  readonly summaries: string[];
  readonly surveyId: string;
  readonly onComplete?: () => void;
}

const SurveySummaryEntry = ({ summaries, surveyId, onComplete }: SurveySummaryEntryProps): ReactElement => {
  const summary = summaries.join('<br><br>');
  const summaryRef = useRef<HTMLDivElement | null>(null);
  const isFontLoaded = useFontFaceObserver([{ family: 'BasisGrotesquePro' }]);
  const hasAnimated = useSelector((state: RootState) => state.surveyAnimationState.hasAnimatedSummary[surveyId]);

  useGSAP(() => {
    if (!isFontLoaded || hasAnimated) {
      return;
    }

    const timeline = gsap.timeline();
    const splitText = new SplitText(summaryRef.current, { type: 'lines', timeline });
    const lines = splitText.lines;

    timeline.from(lines, {
      duration: 1,
      opacity: 0,
      stagger: 0.1,
      onComplete: () => {
        onComplete && onComplete();
      },
    });
  }, [summary, isFontLoaded]);

  const renderSummary = () => {
    return (
      <div
        className=""
      >
        <div className="">
          <div
            className="text-base"
            ref={summaryRef}
            dangerouslySetInnerHTML={{ __html: summary }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-row gap-4">
      <div className="flex flex-col shrink-0 size-8 rounded-2xl bg-true-black items-center justify-center">
        <NoNameLogo
          className="h-[18px]"
          fill="white"
        />
      </div>
      <div className="flex flex-col gap-2">
        {renderSummary()}
      </div>
    </div>
  );
};

export default SurveySummaryEntry;
